import { Log } from "@src/utils";
import { PushNotificationFromJSONTyped } from "@merit/notifications-push-notifications";
import { create } from "zustand";
import type { NotificationResponse } from "expo-notifications";
import type { PushNotification } from "@merit/notifications-push-notifications";

type PushNotificationPayloadState = {
  readonly clearPayload: () => void;
  readonly payload: PushNotification | undefined;
  readonly setPayloadFromNotificationResponse: (response: NotificationResponse) => void;
};

export const usePushNotificationPayloadStore = create<PushNotificationPayloadState>()(set => ({
  clearPayload: () => {
    set({ payload: undefined });
  },
  payload: undefined,
  setPayloadFromNotificationResponse: (response: NotificationResponse) => {
    const data = response.notification.request.content.data;

    // the typing isn't correct, data _can_ be undefined, such as local push notification
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (data?.notificationType === undefined) {
      return;
    }

    try {
      const payload = PushNotificationFromJSONTyped(data, false);
      set({ payload });
    } catch (err) {
      Log.error("push notification payload is not a recognized type", {
        err,
      });
    }
  },
}));
